// 文件路径：src/components/GoTop.vue

<template>
  <button v-show="show" @click="goTop" class="go-top" type="button">
    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 15l6-6 6 6" /></svg>
    <span>TOP</span>
  </button>
</template>

<script>
import { kanonUI } from "@/composables/kanonUI";

export default {
  data() {
    return {
      scrolled: false, // 页面本身是不是已经往下滚了
      kanonUI,
    };
  },
  computed: {
    // 全屏菜单抽屉、预约弹窗打开时都是 lockBodyScroll() 把 body 锁成 position:fixed，
    // 理论上这时候滚的是抽屉/弹窗自己内部的滚动条，不该影响 window.scrollY；
    // 但抽屉/弹窗都是盖在最上层的全屏浮层，这个 TOP 按钮的 z-index 比它们还高，
    // 一旦真滚出了 window.scrollY > 0（不管什么原因），就会穿透浮层露出来，很怪。
    // 所以直接钉死：只要抽屉或预约弹窗有一个开着，这个按钮就不显示，不依赖滚动这件事本身
    show() {
      return this.scrolled && !kanonUI.showDrawer && !kanonUI.showBookingModal;
    },
  },
  methods: {
    goTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    checkScroll() {
      // 显示向上箭头的条件从超过一屏修改为任何向下滚动
      this.scrolled = window.scrollY > 0;
    }
  },
  mounted() {
    window.addEventListener("scroll", this.checkScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.checkScroll);
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/variables.scss";

// 跟 footer 里那个"TOP"按钮改成同一套样式：圆角实心绿块 + 白色箭头/文字。
// 这个是全局常驻的（App.vue 里挂的，所有页面都在），首页额外有个吸底工具栏
// (KanonBottomBar) 占了屏幕最下面 ~54px，这里往上提一截避免重叠。
.go-top {
  position: fixed;
  bottom: 190px;
  right: 10px;
  width: 40px;
  height: 40px;
  border: none;
  // border-radius: $radius-card;
  background: $color-primary;
  color: $color-white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.5px;
  cursor: pointer;
  z-index: 1000;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
}
</style>
